import { Card, Grid, Group, Stack, Title } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';

import { trpc } from '../../../../../services/trpc';
import { GenerateInvoiceButton } from './-generate-invoice-button';
import { PaymentSection } from './-payment-section';
import { AddPaymentButton } from './-payment-section/-add-payment-button';
import { ProjectDetails } from './-project-details';
import { ProjectsSummary } from './-projects-summary';

export const Route = createFileRoute('/app/projets/$slug/facturation/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();

  const { data: project } = trpc.projects.get.useQuery({
    slug,
  });
  const { data: projects } = trpc.projects.listCustomerProjects.useQuery(
    {
      customerId: project!.customerId!,
    },
    {
      enabled: !!project?.customerId,
    },
  );

  if (!project) return null;

  return (
    <Grid mb="xl" gutter="md">
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Stack style={{ minWidth: '280px' }}>
          <Title order={3}>Projets</Title>
          {projects?.map(project => (
            <Card key={project.id}>
              <ProjectDetails project={project} />
            </Card>
          ))}
          <ProjectsSummary projects={projects ?? []} />
        </Stack>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Stack style={{ minWidth: '280px' }}>
          <Group justify="space-between" style={{ flexWrap: 'wrap' }}>
            <Title order={3}>Paiements</Title>
            <AddPaymentButton customerId={project.customer.id} />
          </Group>
          <Card>
            <PaymentSection customer={project.customer} />
          </Card>
          <Group justify="flex-end">
            <GenerateInvoiceButton customerId={project.customerId} project={project} />
          </Group>
        </Stack>
      </Grid.Col>
    </Grid>
  );
}
